import { wechatTeacherService, CONTENT_TYPE} from './instance.js'
// import {getSignHeader} from '@/utils/getSignHeader.js'

export const transformRequest = [(data) => {
  let ret = ''
  for (let it in data) {
    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
  }
  ret = ret.slice(0, -1)
  return ret
}]
// 获取栏目集合分页接口：http://yapi.techgp.cn/project/123/interface/api/10364
export const fetchColumnCollection = async (props) =>{
  let {channel = '', appCode = '', pageSize = 30, pageNo = 1, subCodeList} = props
  let params = {
    pageSize,
    pageNo,
    subCodeList
  }
  let headers = {
    'Content-Type': CONTENT_TYPE.json,
    'appCode': appCode
  }
  const res =  await wechatTeacherService.post(`/rjhy-news-center/api/center/1/column/${channel}/list/bySubCode`, params, {headers})
  return res.data
}

// 通过专题code获取专题接口：http://yapi.techgp.cn/project/123/interface/api/17619
export const fetchSubjectDetail = async (props) =>{
  let {channel = '', subCode} = props
  let params = {
    subCode
  }
  let headers = {
    'Content-Type': CONTENT_TYPE.json
  }
  const res =  await wechatTeacherService.get(`/rjhy-news-center/api/center/1/news/subject/${channel}/by/subCode`,{ params, headers })
  return res.data
}
